import type { ECharts } from "echarts/core";
import type { JSX } from "react";
import type { PlotLayout } from "../layout/plot-layout";
import { bandRowBox } from "./band-geometry";
import { BandTimePills } from "./band-time-pills";
import type { BandHover, PanelBand } from "./use-panel-band";

export function BandOverlay({
    band,
    hovered,
    chart,
    layout,
    panelWidthPx,
}: {
    band: PanelBand;
    hovered: BandHover["hovered"];
    chart: ECharts | null;
    layout: PlotLayout;
    panelWidthPx: number;
}): JSX.Element {
    return (
        <>
            <BandTimePills
                chart={chart}
                layout={layout}
                panelWidthPx={panelWidthPx}
                position={band.position}
                hovered={hovered}
            />
            {band.isError && (
                <div
                    className={
                        "pointer-events-none absolute flex items-center justify-center text-[11px] text-muted-foreground"
                    }
                    style={{
                        left: layout.gutters.left,
                        right: layout.gutters.right,
                        ...bandRowBox(layout, band.position),
                    }}
                >
                    Couldn't load irrigation history
                </div>
            )}
        </>
    );
}
